/** Koyu panel / modal formları — okunaklı kontrast */
export const PANEL_INPUT =
    "w-full rounded-md border border-white/15 bg-[#121A2F] px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 outline-none transition focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37]";

export const PANEL_SELECT = `${PANEL_INPUT} mbs-panel-native-select`;

export const PANEL_MODAL_SHELL =
    "relative w-full max-w-2xl bg-[#121A2F] border border-[#D4AF37]/25 rounded-xl shadow-2xl flex flex-col max-h-[min(92vh,900px)] text-slate-100";

export const PANEL_SECTION =
    "rounded-lg border border-white/10 bg-[#0B0F19]/80 overflow-hidden";
